if (!customElements.get('ff-product-media-gallery')) {
  customElements.define('ff-product-media-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.ff-product-media__track');
      const slides = [...this.querySelectorAll('[data-media-slide]')];
      const buttons = [...this.querySelectorAll('[data-media-index]')];
      if (!track || !slides.length) return;
      const show = (index) => {
        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'instant'});
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      buttons.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.mediaIndex))));
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const current = Math.round(track.scrollLeft / track.clientWidth);
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        const current = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      }, {passive: true});
    }
  });
}
